import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const COPY = {
  DISABLE_ACCOUNT: {
    title: "Disable account",
    confirmLabel: "Disable account",
    getMessage: (username, subject = "post") =>
      `Disable ${
        username ? `@${username}'s` : "this user's"
      } account? They will no longer be able to log in. This does not hide the ${subject} — use Disable ${
        subject === "comment" ? "Comment" : "Post"
      } for that.`,
  },
  BAN_ACCOUNT: {
    title: "Ban account",
    confirmLabel: "Ban account",
    getMessage: (username, subject = "post") =>
      `Ban ${
        username ? `@${username}` : "this user"
      }? This blocks login, forfeits in-progress matches, and soft-deletes their account and related content${
        subject === "live" ? "." : ", including this post."
      }`,
  },
};

export const getAuthorAccountState = (author) => {
  if (!author || author.isDeleted) {
    return author?.isAccountBlocked ? "banned" : "deleted";
  }
  if (author.isAccountBlocked) return "disabled";
  return "active";
};

const AccountActionDialog = ({
  open,
  action,
  username,
  subject = "post",
  busy,
  onClose,
  onConfirm,
}) => {
  const copy = COPY[action];
  if (!copy) return null;

  return (
    <Dialog
      sx={{
        "& .MuiDialog-container .MuiPaper-elevation": {
          borderRadius: "8px",
          width: "420px",
        },
      }}
      open={open}
      onClose={busy ? undefined : onClose}
    >
      <DialogTitle
        sx={{
          padding: "30px 16px 0",
          textAlign: "center",
          fontWeight: 700,
          color: "red",
        }}
      >
        {copy.title}
      </DialogTitle>
      <DialogContent sx={{ padding: "0 16px 20px" }}>
        <Typography sx={{ textAlign: "center", color: "#666" }}>
          {copy.getMessage(username, subject)}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: "0 16px 20px" }}>
        <Button
          onClick={onClose}
          disabled={busy}
          sx={{
            border: "1px solid #888",
            color: "#888",
            borderRadius: "6px",
            fontSize: "14px",
            "&:hover": {
              backgroundColor: "#b9b9b9",
              color: "#222",
              borderColor: "#b9b9b9",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={busy}
          variant="contained"
          sx={{
            backgroundColor: action === "BAN_ACCOUNT" ? "#c62828" : "red",
            color: "#fff",
            borderRadius: "6px",
            fontSize: "14px",
            "&:hover": {
              backgroundColor: action === "BAN_ACCOUNT" ? "#b71c1c" : "red",
            },
          }}
        >
          {busy ? "Working…" : copy.confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountActionDialog;
